import {pxToRem} from '../../../../../utills/pxToRem'

export const getGpayStyles = (isMiniCart) => {
    const height = pxToRem(isMiniCart ? 44 : 40)
    const paddingY = pxToRem(isMiniCart ? 10 : 8)
    const paddingX = pxToRem(20)

    return {
        '.gpay-button': {
            width: '100%',
            height,
            padding: `${paddingY} ${paddingX} !important`,
            borderRadius: 0
        },
        '.adyen-checkout__paywithgoogle': {
            mt: 1, // cleaner than '0.5rem'
            width: isMiniCart ? '90% !important' : '100%',
            height
        }
    }
}
